module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audience-product-wrapper",
    attrs: {
      "id": "audiences"
    }
  }, [_c('div', {
    staticClass: "block-heading-font-style"
  }, [_vm._v("MikMak Video Shopper Audiences")]), _vm._v(" "), _c('div', {
    staticClass: "block-subheading-font-style"
  }, [_vm._v("Generate and own qualified audiences from social video. Take immediate action on these audiences by leveraging our Facebook integration or directly adding them to your CRM.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "audience-product-block-desktop-button",
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": _vm.logCtaClick
    }
  }, [_vm._v("\n    Act on your Audiences\n  ")]), _vm._v(" "), _c('a', {
    staticClass: "mobile-cta-button",
    class: [_vm.shouldShowMainCta ? 'mobile-cta-button-visible' : 'mobile-cta-button-hidden'],
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": _vm.logCtaClick
    }
  }, [_vm._v("\n    Act on your Audiences\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audience-product-block"
  }, [_c('span', {
    staticClass: "audience-product-block-item"
  }, [_c('img', {
    staticClass: "audience-product-image",
    attrs: {
      "src": require("./social-audience-right.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "audience-product-block-header"
  }, [_vm._v("\n        Social Audiences\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "audience-product-block-subheader"
  }, [_vm._v("\n        Build qualified audiences through engagement\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "audience-product-block-body"
  }, [_vm._v("\n        MikMak Attach qualifies your leads from social video views and turns them into new custom audiences for you to take immediate action on.\n      ")])]), _vm._v(" "), _c('span', {
    staticClass: "audience-product-block-item"
  }, [_c('img', {
    staticClass: "audience-product-image",
    attrs: {
      "src": require("./direct-audience-left.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "audience-product-block-header"
  }, [_vm._v("\n        Direct Audiences\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "audience-product-block-subheader"
  }, [_vm._v("\n        Easily create & own direct audiences\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "audience-product-block-body"
  }, [_vm._v("\n        MikMak Attach converts social video views into email addresses and cell phone numbers that your brand can add to its CRM database.\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f1d28d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/AttachProductComponents/AudiencesProductComponent.vue
// module id = 485
// module chunks = 0